'use client';

import React from 'react';
import Background from '@/components/deep-mining/background';
import { toast } from 'sonner';
import type { MobileMessageConfig } from '@/components/mobile-detector';
import Copyright from './copyright';
import copy from 'copy-to-clipboard';
import { useI18n } from '@/hooks/use-i18n';

interface MobileNoticeProps {
  messageConfig: MobileMessageConfig;
}

export function MobileNotice({ messageConfig }: MobileNoticeProps) {
  const { t } = useI18n('components');

  const handleClick = () => {
    copy(window.location.href);
    toast.success(t('mobileNotice.copySuccess'), {
      position: 'top-center',
    });
  };

  return (
    <div className="w-full h-[calc(var(--vh)_*_100)] flex flex-col">
      <div className="relative flex-1">
        <Background />
        <Copyright />
      </div>
      <div className="flex flex-col items-center justify-center gap-2 p-4 mb-1 bg-white">
        <div className="text-[12px] text-[#33333382]">
          {messageConfig.message}
        </div>
        <div
          className="text-[14px] text-white bg-[#7171EE] px-6 py-2 rounded-[100px] cursor-pointer"
          onClick={handleClick}
        >
          {messageConfig.buttonText}
        </div>
      </div>
    </div>
  );
}
